import { render, staticRenderFns } from "./issueRiskActionPlan.vue?vue&type=template&id=cc6eafc6"
import script from "./issueRiskActionPlan.vue?vue&type=script&lang=js"
export * from "./issueRiskActionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc6eafc6')) {
      api.createRecord('cc6eafc6', component.options)
    } else {
      api.reload('cc6eafc6', component.options)
    }
    module.hot.accept("./issueRiskActionPlan.vue?vue&type=template&id=cc6eafc6", function () {
      api.rerender('cc6eafc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iei/issueRiskActionPlan.vue"
export default component.exports